import * as Sentry from '@sentry/react'

const isSentryInitialized = (): boolean => !!Sentry.getCurrentHub().getClient()

export default isSentryInitialized
